<template>
  <div class="relative inline-block text-left" @keydown.escape.stop="open = false" data-kebab-root>
    <button
      class="text-gray-400 hover:text-gray-600"
      @click.stop="open = !open"
      aria-haspopup="true"
      :aria-expanded="open"
    >
      ⋮
    </button>
    <div v-if="open" class="absolute right-0 mt-2 w-44 origin-top-right rounded-lg border border-gray-200 bg-white py-2 shadow-lg z-20">
      <slot />
    </div>
  </div>
  
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const open = ref(false)

const onClickOutside = (e) => {
  if (!(e.target.closest && e.target.closest('[data-kebab-root]'))) {
    open.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', onClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', onClickOutside)
})
</script>


